import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';

import { AuthService } from '@unicup-ticketing/auth';
import { from, switchMap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Subscriptions } from '@unicup-ticketing/utils';
import { HeaderAppearanceEvents } from './state/header.state';
import { Dispatcher } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-login',
  imports: [],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly subs: Subscriptions = new Subscriptions();

  static readonly DEFAULT_REDIRECT_URL = '/';

  private readonly authService = inject(AuthService);

  private readonly router = inject(ActivatedRoute);

  private readonly dispatcher = inject(Dispatcher);

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestHero());

    const requestedUrl = this.router.snapshot.queryParamMap.get('reqUrl');

    this.subs.put(
      this.authService
        .triggerAuthentication(requestedUrl ?? LoginComponent.DEFAULT_REDIRECT_URL)
        .pipe(switchMap(() => from(Promise.resolve(true))))
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribeAll();
  }
}
